module.exports = __webpack_public_path__ + "assets/media/evening.6daf6125.mp3";